import React, { useEffect, useState } from "react";
import AppointmentList from "../../../components/appointmentEC";

import { useOutletContext } from "react-router-dom";

const Appointments = () => {
  const [refresh, setRefresh] = useState(false);
  const [
    data,
    handleRefreh,
    location,
    search,
    handleSearch,
    searchFilterState,
    handleFilterStateActive,
    entireCasesText,
    handleEntireCasesText,
    handleSetConsultantFilter,
    selectedConsultant,
    consultantsList,
  ] = useOutletContext();
  const [list, setList] = useState(data);
  useEffect(() => {
    setList(data);
  }, [data]);
  const handleRefreshByParent = () => {
    setRefresh((pre) => !pre);
    handleRefreh();
  };
  return (
    <AppointmentList
      data={list}
      handleRefresh={handleRefreshByParent}
      search={search}
      handleSearch={handleSearch}
      searchFilterState={searchFilterState}
      handleFilterStateActive={handleFilterStateActive}
      handleEntireCasesText={handleEntireCasesText}
      entireCasesText={entireCasesText}
      handleSetConsultantFilter={handleSetConsultantFilter}
      selectedConsultant={selectedConsultant}
      consultantsList={consultantsList}
    />
  );
};

export default Appointments;
